import React from "react";
import "./DappBusiness.css";
import img1 from '../decentassets/dapp1.png';
import check from "../decentassets/check.png";

export default function DappBusiness() {
  return (
    <div id="dapp-business" className="dappmainclass">
      <div className="right">
        <img src={img1} alt="error" />
      </div>
       <div className="left">
        <h1 className="heading">
      Redefining Digital Applications With Decentralization
 </h1>
        <p>
       Traditional applications rely on centralized servers and third-party control, while DApp Services enable decentralized applications to shift toward blockchain-driven logic, delivering transparency, automation, and secure global interactions. blockchain-driven logic, delivering transparency, automation, and secure global interactions. </p>

        <ul>
          <li>
            <img src={check} alt="error" />
            <span>Tamper-proof Data Integrity</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Trustless Transactions</span>
          </li>
        <li>
            <img src={check} alt="error" />
            <span>Automated Business Logic</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Global Accessibility</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
